import styled from '@emotion/styled'
import { themedValue } from 'component-library/__styling/themed-value'
import { rgba } from 'polished'
import { colors } from 'component-library/__styling/settings'
import { calcRem } from 'component-library/__styling/style-functions'

const wrapperBorder = `2px solid ${colors.thewest.greyElephant}`

export const StyledNavListItem = styled('li')(
    {
        listStyle: 'none',
        borderTop: wrapperBorder,
        borderBottom: wrapperBorder,
        marginBottom: calcRem(-2),
        fontSize: calcRem(16),
    },
    ({ theme }) => ({
        borderBottom: themedValue(theme, {
            sevennews: section => `solid 1px ${rgba(section.mobileNav.textColor, 0.2)}`,
            fallback: undefined,
        }),
    })
)
